import React from "react";
import PictureComponent from "/components/core/picture/picture-component";
import Colors from "/styles/colors";
import { WORK_OS_IRIS_COLOR_NAME } from "styles/color-consts";
import { UNIVERSE_STAR_HOVERED, UNIVERSE_STAR_CLICKED } from "/constants/bigbrain-event-types";
import { trackEvent } from "/services/bigbrain-service";

import { componentStyles } from "./universe-star-tag-component.scss";

const UniverseStarTagComponent = (props) => {
  const { starText, starImage, starColorName } = props;

  const onClick = () => {
    trackEvent(UNIVERSE_STAR_CLICKED, { kind: starText });
  };

  const onMouseOver = () => {
    trackEvent(UNIVERSE_STAR_HOVERED, { kind: starText });
  };

  const starColor = Colors[starColorName] || Colors[WORK_OS_IRIS_COLOR_NAME];
  return (
    <div
      className="universe-star-tag-component"
      style={{ color: starColor }}
      onMouseOver={onMouseOver}
      onClick={onClick}
    >
      <div className="background-circle" />
      <div className="star-image">
        <PictureComponent className="star-icon" pictureClass="star-picture" src={starImage} />
      </div>
      <div className="star-text">{starText}</div>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default UniverseStarTagComponent;

UniverseStarTagComponent.defaultProps = {
  starText: "Marketing",
  starImage:
    "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/Marketing_icon_circle.png",
  starColorName: "marketing-red"
};
